import { Link } from 'gatsby';
import { ChevronRight } from 'lucide-react';
import type { FC } from 'react';

export interface BreadcrumbItem {
  label: string;
  link: string;
}

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

const Breadcrumb: FC<BreadcrumbProps> = ({ items, className = '' }) => {
  if (!items.length) {
    return null;
  }

  return (
    <nav
      aria-label="Breadcrumb"
      className={`site-breadcrumb${className ? ` ${className}` : ''}`}
    >
      <ol className="site-breadcrumb__list">
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;

          return (
            <li className="site-breadcrumb__item" key={`${item.link}-${item.label}`}>
              {idx > 0 ? (
                <ChevronRight
                  aria-hidden
                  className="site-breadcrumb__separator"
                  size={10}
                  strokeWidth={2}
                />
              ) : null}
              {isLast ? (
                <span aria-current="page" className="site-breadcrumb__text">
                  {item.label}
                </span>
              ) : (
                <Link className="site-breadcrumb__link" to={item.link}>
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
